import { t } from "@/i18n-js/instance";
import { OverviewStatComponent } from "@/react/components/Analytics/components/OverviewStatComponent";
import { i18nRoot } from "../../constants";

export const MetricsOverview = () => (
  <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-3">
    <OverviewStatComponent
      title={t([i18nRoot, "analytics.metrics.views.title"])}
      value={135890}
      tooltip={t([i18nRoot, "analytics.metrics.views.tooltip"])}
      className="w-full"
    />
    <OverviewStatComponent
      title={t([i18nRoot, "analytics.metrics.unique_viewers.title"])}
      value={1783212}
      tooltip={t([i18nRoot, "analytics.metrics.unique_viewers.tooltip"])}
      className="w-full"
    />
    <OverviewStatComponent
      title={t([i18nRoot, "analytics.metrics.completion_rate.title"])}
      value={21}
      suffix="%"
      tooltip={t([i18nRoot, "analytics.metrics.completion_rate.tooltip"])}
      className="w-full"
    />
  </div>
);
